// Événements GA4 — wrapper sûr autour de gtag (absent en dev ou sous adblock,
// ne doit jamais casser l'UI). Les conversions du site n'étaient pas mesurées
// du tout : impossible d'optimiser sans ça.
export function track(event, params = {}) {
    try {
        if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
            window.gtag('event', event, params)
        }
    } catch (_) { /* jamais bloquant */ }
}

// Événements Meta Pixel (850925614272900). Le code de base est installé via
// GTM (gaté par le consentement Axeptio) : on ne le réinjecte pas, on émet
// seulement si fbq existe — donc seulement si l'utilisateur a consenti.
export function metaTrack(event, params = {}) {
    try {
        if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
            window.fbq('track', event, params)
        }
    } catch (_) { /* jamais bloquant */ }
}
